import { HorizontalContainer, VerticalContainer } from '@american-autonomy/ag-ui';

import useTranslation from './hooks/useTranslation';

import SpecLabel from './components/SpecLabel';
import SpecValue from './components/SpecValue';
import { TEST_ID } from './constants';
import getDroneSpecs from './helpers/getDroneSpecs';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneCardDetails: FunctionComponent<Props> = ({
    className = '',
    faaRegistrationNumber,
    firmware,
    serial,
    testId = TEST_ID,
    usage,
    warrantyEnd
}) => {
    const {
        DRONE_PREFIX,
        EM_DASH,
        FAA_PREFIX,
        FIRMWARE,
        IDS,
        UNIT_ACRES,
        UNIT_DAYS,
        UNIT_FLIGHTS,
        UNIT_HOURS_SHORT,
        USAGE,
        WARRANTY,
        WARRANTY_EXP_PREFIX,
        WARRANTY_EXPIRED
    } = useTranslation();

    const specs = getDroneSpecs({
        faaRegistrationNumber,
        firmware,
        labels: {
            dronePrefix: DRONE_PREFIX,
            emDash: EM_DASH,
            faaPrefix: FAA_PREFIX,
            firmware: FIRMWARE,
            ids: IDS,
            unitAcres: UNIT_ACRES,
            unitDays: UNIT_DAYS,
            unitFlights: UNIT_FLIGHTS,
            unitHoursShort: UNIT_HOURS_SHORT,
            usage: USAGE,
            warranty: WARRANTY,
            warrantyExpPrefix: WARRANTY_EXP_PREFIX,
            warrantyExpired: WARRANTY_EXPIRED
        },
        now: new Date(),
        serial,
        usage,
        warrantyEnd
    });

    const rows = [specs.usage, specs.warranty, specs.ids, specs.firmware];

    return (
        <VerticalContainer className={`${className} ${styles.droneCardDetails}`} testId={testId}>
            {rows.map(spec => (
                <HorizontalContainer className={styles.specStrip} key={spec.label}>
                    <SpecLabel text={spec.label} />

                    <SpecValue text={spec.value} />
                </HorizontalContainer>
            ))}
        </VerticalContainer>
    );
};

export default DroneCardDetails;
